import axios from 'axios';
import router from '@app/router';
import endpoint from '@app/endpoint';
import { startLoading, endLoading } from '@app/actions/spinnerActions';
import { SET_BRAND_ID_LIST, SET_ATB_CODES_DATA, CLEAR_ATB_CODES_DATA, SET_APPLY_CODES_STEP } from './_types';

export const setBrandIdList = brandIdList => ({
  type: SET_BRAND_ID_LIST,
  payload: brandIdList,
});

export const setATBCodesParsedData = atbCodesData => ({
  type: SET_ATB_CODES_DATA,
  payload: atbCodesData,
});

export const clearATBCodesParsedData = () => ({
  type: CLEAR_ATB_CODES_DATA,
});

export const setApplyCodesStep = applyCodesStep => ({
  type: SET_APPLY_CODES_STEP,
  payload: applyCodesStep,
});

export const parseATBCodesFile = (formData, projectData) => dispatch =>
  new Promise((resolve, reject) => {
    dispatch(startLoading());
    endpoint.parseAtbFile(
      formData,
      projectData,
      ({ data: atbCodesParsedData }) => {
        dispatch(endLoading());
        resolve(atbCodesParsedData);
      },
      parseErrors => {
        dispatch(endLoading());
        reject(parseErrors);
      },
      this,
    );
  });

export const submitATBCodesRequestForm = (requestFormData, projectData) => dispatch =>
  new Promise((resolve, reject) => {
    dispatch(startLoading());
    endpoint.requestAtbCodes(
      requestFormData,
      projectData,
      codesResponse => {
        dispatch(endLoading());
        resolve(codesResponse);
      },
      codesError => {
        dispatch(endLoading());
        reject(codesError);
      },
      this,
    );
  });

export const fetchBrandIdList = flowConfig => dispatch => {
  const consumerId = router.getCookieValue('consumerId');
  const brandIdRequestURL = flowConfig.getResourceURL('dpo8-brand-id-request');
  const url = brandIdRequestURL.replace('{$consumerId}', consumerId);

  dispatch(startLoading());

  axios
    .get(url, {
      headers: {
        Accept: 'application/xml',
      },
      withCredentials: true,
    })
    .then(response => response.data)
    .then(str => {
      const brandIdList = parseBrandId(str);
      dispatch(setBrandIdList(brandIdList));
      dispatch(endLoading());
    })
    .catch(() => {
      dispatch(endLoading());
    });
};

const parseBrandId = str => {
  const $brandIdXml = new window.DOMParser().parseFromString(str, 'text/xml');
  const [$total] = $brandIdXml.getElementsByTagName('total');
  const [$brands] = $brandIdXml.getElementsByTagName('brands');

  const { childNodes: $brandIds } = $brands;
  const { textContent: codesQuantity } = $total;

  if (!codesQuantity) return [];

  const brandIdList = Array.from($brandIds).map($brandId => $brandId.textContent);
  return brandIdList.filter(id => id.trim() !== '');
};
